const TEMPLATE_NAME = 'DOWNLOAD';

const initialState = () => ({
    loading: false,
    error: {}
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            return {
                ...state,
                loading: false,
            };
        }
        default:
            return state;
    }
};
export default reducer;